var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventorylistheader88(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 7L13.6 3.2C13.2 2.8 12.6 2.8 12.2 3.2C11.8 3.6 11.8 4.2 12.2 4.6L14.8 7.2H3C2.4 7.2 2 7.6 2 8.2C2 8.8 2.4 9.2 3 9.2H14.8L12.2 11.8C11.8 12.2 11.8 12.8 12.2 13.2C12.6 13.6 13.2 13.6 13.6 13.2L17.4 9.4C18.2 8.6 18.2 7.8 17.4 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.6 17L10.4 20.8C10.8 21.2 11.4 21.2 11.8 20.8C12.2 20.4 12.2 19.8 11.8 19.4L9.2 16.8H21C21.6 16.8 22 16.4 22 15.8C22 15.2 21.6 14.8 21 14.8H9.2L11.8 12.2C12.2 11.8 12.2 11.2 11.8 10.8C11.4 10.4 10.8 10.4 10.4 10.8L6.6 14.6C5.8 15.4 5.8 16.2 6.6 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventorylistheader88);
export default __webpack_public_path__ + "static/media/inventorylistheader-88.acc0929058f6abcf8d4d93449cdbfa12.svg";
export { ForwardRef as ReactComponent };